import React, { useState } from 'react';
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';
import Modal from '../../Modal';
import moment from 'moment';

const RenderItem = ({ removeVoucher, item, requested, err, isMainAdmin = true }: any) => {
    {
        const [basicModal, setBasicModal] = useState(false);

        const toggleOpen = () => setBasicModal(!basicModal);

        // Two distinct numbers backed by the new originalMaxUsage schema field:
        //   - cap (Max No. of Usage)  = the original quota set at creation time
        //   - left (Left Usage)       = the remaining redemptions (decremented per use)
        // Legacy vouchers created before this change have no originalMaxUsage,
        // so we fall back to displaying just maxUsageCount with a "—" cap to
        // be honest about the missing history.
        const hasOriginal = typeof item?.originalMaxUsage === "number" && item.originalMaxUsage > 0;
        const cap = hasOriginal ? item.originalMaxUsage : null;
        const left = typeof item?.maxUsageCount === "number" ? item.maxUsageCount : null;
        const isExhausted = left === 0;

        return (
            <>
                <tr style={isExhausted ? { backgroundColor: 'rgba(255, 99, 99, 0.07)' } : undefined}>
                    <td>{String(item?.voucherCode || '-').toUpperCase()}</td>
                    <td>{moment(new Date(item?.startDate)).format('MMMM Do YYYY hh:mm A') || "-"}</td>
                    <td>{moment(new Date(item?.endDate)).format('MMMM Do YYYY hh:mm A') || "-"}</td>
                    <td>{item?.discountAmt ? `₹${item?.discountAmt}` : "-"}</td>
                    <td>{cap != null ? cap : "—"}</td>
                    <td>
                        <span style={{ marginRight: isExhausted ? 8 : 0 }}>{left != null ? left : "-"}</span>
                        {isExhausted ? (
                            <span style={{
                                display: 'inline-block',
                                padding: '2px 8px',
                                borderRadius: 999,
                                background: '#dc3545',
                                color: '#FFFFFF',
                                fontSize: 11,
                                fontWeight: 700,
                                letterSpacing: 0.5,
                                verticalAlign: 'middle',
                            }}>EXHAUSTED</span>
                        ) : null}
                    </td>
                    <td>{item?.minHoursToApply || "-"}</td>
                    <td>{Array.isArray(item?.applicableServices) && item.applicableServices.length ? item.applicableServices.join(', ') : 'All services'}</td>
                    <td style={{ display: 'flex', gap: '10px' }}>
                        {isMainAdmin ? (
                            <MDBBtn onClick={toggleOpen} color='danger'>Remove</MDBBtn>
                        ) : (
                            <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem' }}>View only</span>
                        )}
                    </td>
                </tr>
                <Modal open={!err && !requested && basicModal} title='Remove Code' onConfirm={() => { removeVoucher(item?._id) }} toggleOpen={toggleOpen} content={<h6>Are you sure about removing the code ?</h6>} />
            </>
        );
    }
}

export default RenderItem;